import { render } from "./aboutSelloMate.vue?vue&type=template&id=bf8b7bec"
import script from "./aboutSelloMate.vue?vue&type=script&lang=js"
export * from "./aboutSelloMate.vue?vue&type=script&lang=js"

import "./aboutSelloMate.vue?vue&type=style&index=0&id=bf8b7bec&lang=scss"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__